import stripMarkdown from './stripMarkdown';

export default function markdownPreview(text: string): string {
  let previewText = stripMarkdown(text);
  if (previewText.length > 80) {
    previewText = `${previewText.substring(0, previewText.lastIndexOf(' ', 80))}...`;
  }

  return previewText;
}
